import { render, staticRenderFns } from "./ContributionDetail.vue?vue&type=template&id=a4975222&"
import script from "./ContributionDetail.vue?vue&type=script&lang=js&"
export * from "./ContributionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports